import process from "process";
// import root from "window-or-global";
if (!window.process) {
  window.process = process;
}

import React from "react";
import {createRoot} from "react-dom/client";
import "chart.js/auto";
import "./logic/logger";
import "./logic/i18n";
import Page from "./pages/index";
// import "@babel/runtime/helpers/interopRequireDefault"; // ensure it is loaded
// import * as RGL from "react-grid-layout/legacy";
// console.log("ResponsiveGridLayout loaded", RGL);

// ResponsiveGridLayout = RGL.WidthProvider(RGL.Responsive);

export let ResponsiveGridLayout = {};
// export const ResponsiveGridLayout = {};
import config from "./config";
async function init() {
  // await loadApiPath();
  const RGL = await import("react-grid-layout/legacy");
  ResponsiveGridLayout = RGL.WidthProvider(RGL.Responsive);

  console.log("Initializing app...", RGL);
  createRoot(document.getElementById("root")).render(<Page />);
}
init();


async function loadApiPath() {
  try {

    const response = await fetch("/api.json");
    const data = await response.json();
    console.log("api.json - data", data);
    Object.keys(data).forEach((k) => (config[k] = data[k]));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("unable to find api.json file");
  }
  // if (!config.apiPath || config.apiPath === "") {
  //   config.apiPath = "http://localhost:7080";
  // }
}
